import { render } from "./cNodata.vue?vue&type=template&id=91785ab8&scoped=true"
import script from "./cNodata.vue?vue&type=script&lang=js"
export * from "./cNodata.vue?vue&type=script&lang=js"

import "./cNodata.vue?vue&type=style&index=0&id=91785ab8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91785ab8"],['__file',"src/components/cmp/cNodata/cNodata.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "91785ab8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('91785ab8', __exports__)) {
    api.reload('91785ab8', __exports__)
  }
  
  module.hot.accept("./cNodata.vue?vue&type=template&id=91785ab8&scoped=true", () => {
    api.rerender('91785ab8', render)
  })

}


export default __exports__